module.exports = __webpack_public_path__ + "static/media/DCG_sticker_01_black_bg.6b7489b1.png";